// extracted by mini-css-extract-plugin
export default {"main":"Main_main__3atbt","flareAnimation":"Main_flareAnimation__EHPJJ"};